// src/components/GamesLoader.js
import React from "react";

export default function GamesLoader() {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-3 text-slate-300">
      {/* Spinner */}
      <div className="h-8 w-8 border-4 border-emerald-500/60 border-t-transparent rounded-full animate-spin" />
      
      {/* Message */}
      <div className="text-sm uppercase tracking-wide text-slate-400">
        loading games list
      </div>
    </div>
  );
}
